import { reactNodeContains } from 'module/helpers/react-node-content-contains';
import { MenuItem as MenuItemType, MenuGroup } from './types';

export const isMenuGroup = (item: MenuItemType): item is MenuGroup => {
  return 'subMenu' in item;
};

export const getAllKeysFromMenuItems = (items: MenuItemType[]): string[] => {
  return items.reduce((acc: string[], item) => {
    if (isMenuGroup(item)) {
      acc.push(item.key);
      acc.push(...getAllKeysFromMenuItems(item.subMenu));
    }

    return acc;
  }, []);
};
const isRouteMatch = (
  route: string | undefined,
  currentPath: string,
): boolean => {
  if (!route) {
    return false;
  }

  return route === currentPath || currentPath.startsWith(`${route}/`);
};

export const getActiveMenuKeysForPath = (
  items: MenuItemType[],
  currentPath: string,
  alreadyActiveKeys: string[] = [],
): string[] => {
  const activeKeys = new Set<string>(alreadyActiveKeys);
  const addKeyIfSubMenuActive = (item: MenuItemType) => {
    if (isMenuGroup(item)) {
      return item.subMenu.some((subItem) => {
        if (!isMenuGroup(subItem)) {
          if (isRouteMatch(subItem.route, currentPath)) {
            activeKeys.add(item.key);

            return true;
          }
        } else {
          const subMenuActive = addKeyIfSubMenuActive(subItem);

          if (subMenuActive) {
            activeKeys.add(item.key);
          }

          return subMenuActive;
        }

        return false;
      });
    }

    return false;
  };

  items.forEach((item) => {
    addKeyIfSubMenuActive(item);
  });

  return Array.from(activeKeys);
};
export const getFilteredLeftMenuItems = (
  menuItems: MenuItemType[],
  searchText: string,
) => {
  const filterMatchMenus = (item: MenuItemType) => {
    if (reactNodeContains(item.menuName, searchText)) {
      return item;
    }
    if (isMenuGroup(item)) {
      const matchSubMenus = item.subMenu
        .map(filterMatchMenus)
        .filter((item): item is MenuItemType => item !== null);

      if (matchSubMenus.length > 0) {
        return {
          ...item,
          subMenu: matchSubMenus,
        };
      }

      return null;
    }

    return null;
  };

  return menuItems
    .map((item) => filterMatchMenus(item))
    .filter((item): item is MenuItemType => item !== null);
};
